import * as yup from 'yup'

export const validateUpdatePriceList = yup.object().shape({
    name: yup
    .string()
    .min(3, 'El NOMBRE debe tener más de 2 caracteres'),
    integration_id: yup
    .string()
    .min(3, 'El ID de INTEGRACIÓN debe tener más de 2 caracteres'),
})